// extracted by mini-css-extract-plugin
export default {"questionsBlock":"QuestionsBlock_questionsBlock__PCL9S","title":"QuestionsBlock_title__mNtuN","button":"QuestionsBlock_button__2YytG","fAQList":"QuestionsBlock_fAQList__vR+u-"};